// import { AgmCoreModule } from '@agm/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import { appReducers } from './store/app.reducers';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './shared/auth/auth.module';
import { CONSTANTS } from './shared/constants';
import { EffectsArray } from './store/effects';
import { environment } from '../environments/environment';
import { IconSetModule } from './shared/modules/icon-set/icon-set.module';
import { TOAST_OPTIONS } from './utils/toast-config';

const config: SocketIoConfig = {
  url: environment.NOTIFICATION_API,
  options: {
    // Token inicial; tras login se actualiza con SocketService.reconnectWithAuth()
    auth: {
      token: localStorage.getItem(CONSTANTS.accessToken)
    },
    autoConnect: true,
    reconnection: true
  }
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AuthModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(appReducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25, logOnly: environment.production
    }),
    EffectsModule.forRoot(EffectsArray),
    ToastrModule.forRoot(TOAST_OPTIONS),
    LazyLoadImageModule,
    IconSetModule,
    SocketIoModule.forRoot(config)
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
